export default "__VITE_ASSET__C$i7Tm5p__"